// Pure decision logic for the presence store (stores/presence.js): which
// tracked user ids actually need a fetch, and how to batch them for
// GET /api/users/public/presence. Kept free of MobX/network so it can be
// unit tested (tests/lib/presence.test.js).

// Matches the backend: online = active within the last 7 minutes, and the
// webapp refreshes a shown dot at most once per minute.
export const PRESENCE_TTL_MS = 60 * 1000;
// Matches MAX_IDS in backend/app/routes/api/users/get-public-presence.js.
export const PRESENCE_BATCH_MAX = 100;

export function normalizeUserId(value) {
    const id = parseInt(value, 10);
    return id > 0 ? id : null;
}

export function idsToFetch(ids, fetchedAtByUserId, nowMs, ttlMs = PRESENCE_TTL_MS) {
    const unique = [...new Set(ids)];
    return unique.filter(id => {
        const fetchedAt = fetchedAtByUserId[id];
        return !(fetchedAt && (nowMs - fetchedAt) < ttlMs);
    });
}

export function chunkIds(ids, size = PRESENCE_BATCH_MAX) {
    const chunks = [];
    for (let i = 0; i < ids.length; i += size) {
        chunks.push(ids.slice(i, i + size));
    }
    return chunks;
}

export default {
    PRESENCE_TTL_MS,
    PRESENCE_BATCH_MAX,
    normalizeUserId,
    idsToFetch,
    chunkIds,
};
